"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProfileDropdown = function (_a) {
    var closeProfileDropdown = _a.closeProfileDropdown, _b = _a.withReferral, withReferral = _b === void 0 ? true : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    var _c = (0, swr_hooks_1.usePlayerStatus)(), nextLevelInfo = _c.nextLevelInfo, userPoints = _c.userPoints, nextLevelMin = _c.nextLevelMin, progressPercents = _c.progressPercents;
    var signOut = (0, swr_hooks_1.useSignOut)().signOut;
    var handleSignOut = (0, react_1.useCallback)(function () {
        closeProfileDropdown();
        signOut();
    }, [signOut, closeProfileDropdown]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.profileDropDownContent },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.profileStatusBarWrapper },
            withReferral && react_1.default.createElement(ui_components_1.ReferralLink, null),
            react_1.default.createElement("div", null,
                t('nextStatus'),
                ":"),
            (nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.name) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.userStatus }, nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.name)),
            (nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.name) ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.statusBar },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.statusProgress, style: { width: "".concat(progressPercents, "%") } },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.glareBar }))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.compPoints },
                    userPoints,
                    "/",
                    nextLevelMin,
                    " (",
                    progressPercents,
                    "%)"))) : null),
        react_1.default.createElement("ul", { className: styles_module_scss_1.default.profileMenu },
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/account/wallet/balance") }, t('myAccount'))),
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/account/bonuses/cash") }, t('bonuses'))),
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/account/history/bets") }, t('history'))),
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/account/history/transactions") }, t('history'))),
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/games/favorites") }, t('favorites')))),
        react_1.default.createElement("ul", { className: styles_module_scss_1.default.profileMenu },
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: handleSignOut },
                react_1.default.createElement("span", null, t('signOut'))))));
};
exports.default = ProfileDropdown;
